module.exports = __webpack_public_path__ + "img/project4_2.9b0be6ed.png";